<template>
    <div>
        <!-- confirm dialog -->
        <v-dialog width="400" v-model="confirmDialog">
            <v-card>
                <div class="d-flex justify-end py-1 red-light-one-bg ">
                    <v-card-title
                        class="text-uppercase text-subtitle-1 d-flex justify-center w-100 px-0 py-0 white--text"
                    >
                        {{ $t('LoanedItems.confirm-dialog') }}
                    </v-card-title>
                    <!-- close button -->
                    <v-btn icon @click="confirmDialog = false; isRestore = false">
                        <v-icon color="white">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </div>

                <v-card-text class="pt-2 pb-0">
                    {{ $t('LoanedItems.confirm-message') }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="red lighten-1"
                        class="white--text"
                        small
                        @click="restore()"
                        :disabled="submitLoading"
                    >
                        {{ $t('yes') }}
                    </v-btn>
                    <v-btn
                        text
                        small
                    >
                        {{ $t('cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col class="pb-0">
                <h1 class="text-h6 primary--text text-capitalize">
                    {{$t('routes.loaned-items')}}
                </h1>
            </v-col>
        </v-row>
       
        <!-- filter -->
        <v-row class="mt-1">
            <v-col cols="4" sm="4"  md="2">
                <v-autocomplete
                    v-model="medicalRepIds"
                    :items="medicalreps"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.medical-rep')"
                    outlined
                    dense
                    hide-details
                    multiple
                    :loading="loading"
                    :disabled="loading || type !== null"
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        >
                            (+{{ medicalRepIds.length - 1 }})
                        </span>
                    </template>   
                </v-autocomplete>
            </v-col>

            <!-- type -->
            <v-col cols="4" sm="4"  md="2">
                <v-autocomplete
                    v-model="type"
                    :items="entityTypes"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.type')"
                    outlined
                    dense
                    hide-details
                    :loading="loading"
                    :disabled="loading || loadingEntity || Boolean(medicalRepIds.length)"
                    @change="getEntity()"
                />
            </v-col>

            <!-- doctor -->
            <v-col cols="4" sm="4"  md="2">
                <v-autocomplete
                    v-model="entityId"
                    :items="entitiesBrief"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.doctor')"
                    outlined
                    dense
                    hide-details
                    :loading="loading || loadingEntity"
                    :disabled="loading || !type"
                />
            </v-col>

            <!-- items -->
            <v-col cols="4" sm="4"  md="2">
                <v-autocomplete
                    v-model="materialId"
                    :items="materials"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.item')"
                    outlined
                    dense
                    hide-details
                    :loading="loading"
                    :disabled="loading"
                />
            </v-col>

            <!--  -->
            <v-col cols="auto" class="pt-0" align-self="center">
                <v-radio-group
                    v-model="dateType"
                    row
                    class="mt-0"
                    hide-details
                    :disabled="loading"
                >
                <v-radio
                    :label="$t('daily-date')"
                    value="1"
                ></v-radio>
                <v-radio
                    :label="$t('from-date-to-date')"
                    value="2"
                ></v-radio>
                </v-radio-group>
            </v-col>

            <v-col cols="2" v-if="dateType === '2'" class="py-0" align-self="center">
                <bee-date-picker
                    v-model="startDate"
                    input-label="Start Date"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        disable: loading
                    }"
                ></bee-date-picker>
            </v-col>

            <!-- end date -->
            <v-col v-if="dateType === '2'" cols="2" class="pt-0 " align-self="center">
                <bee-date-picker
                    v-model="endDate"
                    input-label="End Date"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        disable: loading
                    }"
                ></bee-date-picker>
            </v-col>

            <!-- filter -->
            <v-col v-if="dateType === '1'" cols="6" sm="5"  md="3" class="pa-1 pt-0" align-self="center">
                <bee-date-input
                    v-model="date"
            	    :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'"
					:prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'"
                    :label="$t('inputs.date')"
                    input-format-order="DD-MM-YYYY"
                    dense
                    :loading="loading"
                    :disabled="loading"
                    hide-details
                    @click:append="addDate()"
                    @click:prepend="subDate()"
                ></bee-date-input>
            </v-col>

            <v-col cols="auto" class="mb-2 pt-0" align-self="center">
                <v-btn
                	color="success"
                	small
                	:loading="loading"
                	:disabled="loading"
                    @click="getLoanedMaterials()"
                >
                    {{ $t('search') }}
                </v-btn>
                <v-btn
                	color="alert-color white--text"
                	class="mx-1"
                	small
                	:disabled="loading"
                    @click="reset()"
                >
                    {{ $t('reset') }}
                </v-btn>
            </v-col>
        </v-row>    
        <bee-handy-table
            :headers="headers"
            :items="items"
            zebra
            dense
            :height="$vuetify.breakpoint.height - 120"
            :shown-rows-text="$t('shown-rows')"
            pagination-on-scroll
            @dblclick:row="goToStatement"
        >
            <template v-slot:item.actions="{ item }">
                <v-btn icon @click="isRestore = true; transactionId = item.transactionId; confirmDialog = true">
                    <v-icon> mdi-clipboard-arrow-left  </v-icon>
                </v-btn>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { entityType, transactionState } from '@/helpers/enums'

export default {
    data() {
        return {
            confirmDialog: false,
            medicalRepIds: [],
            entityId: null,
            materialId: null,
            dateType: '1',
            date: moment().format('YYYY-MM-DD'),
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),  
            items: [],
            entityType,
            loading: false,
            entityTypes: [
                { id: entityType.center, name: this.$t('tabs.centers') },
                { id: entityType.doctor, name:  this.$t('tabs.doctor') },
                { id: entityType.pharmacy, name: this.$t('tabs.pharmacies') },
                // { id: entityType.external, name: 'externals' }
            ],
            type: null,
            loadingEntity: false,
            transactionId: null,
            isRestore: false,
            submitLoading: false
        }
    },

    computed: {    
        ...mapState({
            materials: state => state.materials.materials,
            medicalreps: state => state.medicalreps.medicalreps,
            entitiesBrief: state => state.entities.entitiesBrief
        }),

        ...mapGetters({
            getMaterialById: 'materials/getMaterialById',
        }),
        headers () {
            return [
                {
                    text: this.$t('headers.item'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.entity-name'),
                    name: 'fromAccountName',
                    value: 'fromAccountName'
                },
                {
                    text: this.$t('headers.medical-rep-name'),
                    name: 'toAccountName',
                    value: 'toAccountName'
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        goToStatement(item) {
            if (this.isRestore === false) {
                this.$router.replace({
                    name: 'samples-statement',
                    query: {
                        id: item.materialId
                    }
                })
            }
        },

        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            return this.date
        },

        getLoanedMaterials(isFirst) {
            this.loading = true
            this.$store.dispatch('materialTransactions/fetchMaterialLoaned', { 
                materialId: this.materialId, 
                employeeIds: this.medicalRepIds, 
                FromDate: this.dateType === '1' ? moment(this.date).format('YYYY-MM-DD') : this.startDate, 
                ToDate: this.dateType === '1' ? moment(this.date).format('YYYY-MM-DD') : this.endDate, 
                accountIds: this.entityId ? [this.entityId] : []
            }).then((data) => {
                this.items = data.data
            }).finally(() => {
                this.loading = false
            })
        },

        reset() {
            this.materialId = null
            this.medicalRepIds = [] 
            this.startDate = moment().startOf('month').format('YYYY-MM-DD')
            this.endDate = moment().endOf('month').format('YYYY-MM-DD')
            this.date = moment().format('YYYY-MM-DD')
            this.entityId = null
            this.type = null
        },
        getEntity () {
            this.loadingEntity = true
            this.$store.dispatch('entities/fetchAllBrief', { type: this.type }).finally(() => {
                this.loadingEntity = false
            })
        },

        updateWithMedical() {
            this.submitLoading = true
            return this.$store.dispatch('materialTransactions/updateReturnMaterialToMedicalRep', { 
                TransactionId: this.transactionId 
            }).finally(() => {
                this.submitLoading = false
                this.confirmDialog = false
            })
        },

        updateWithSupervisor() {
            this.submitLoading = true
            return this.$store.dispatch('materialTransactions/updateReturnMaterialToSupervisor', { 
                TransactionId: this.transactionId 
            }).finally(() => {
                this.submitLoading = false
                this.confirmDialog = false
            })
        },

        restore() {
            if (this.medicalRepIds.length !== 0) {
                this.updateWithMedical().then(() => {
                    this.getLoanedMaterials()
                })
            } else {
                this.updateWithSupervisor().then(() => {
                    this.getLoanedMaterials()
                })
            }
        }
    },
    
    created() {
        this.loading = true
        Promise.all([
            // this.getLoanedMaterials(true),  
            !this.materials.length ? this.$store.dispatch('materials/fetchAll') : null,
            !this.medicalreps.length ? this.$store.dispatch('medicalreps/fetchAll', true) : null,
            !this.entitiesBrief.length ? this.$store.dispatch('entities/fetchAllBrief', { type: entityType.doctor }) : null
        ]).then(() => {
            this.loading = false
        })
    }
}
</script>
